import {
  dbReducerNorm,
  findById,
  findByIdAsync,
  insert as persistInsert,
  ReduxFindAllNorm,
  ReduxFindByIdNorm,
  removeMany as persistRemoveMany,
  removeOne as persistRemoveOne,
  updateOne,
} from '@weblite/persist'

export function createStorage<T>(collection: string) {
  const insert = persistInsert(collection)
  const removeOne = persistRemoveOne(collection)
  const removeMany = persistRemoveMany(collection)
  const findSync = findById(collection)
  const find = findByIdAsync(collection)
  const update = updateOne(collection)

  const storage = {
    async add(data: T | T[]) {
      await insert(data)
    },
    async del(id: string | string[]) {
      await (Array.isArray(id) ? removeMany(id) : removeOne(id))
    },
    get(id: string): Promise<T> {
      return find(id)
    },
    getSync(id: string): T {
      return findSync(id)
    },
    getAll(): T[] {
      return ReduxFindAllNorm(collection)
    },
    async set(id: string, fields: Partial<T>) {
      await update(id, { $set: fields })
    },
    getFromRedux(id: string): T {
      return ReduxFindByIdNorm(collection, id)
    },
  }

  const reducer = dbReducerNorm(['main', collection])

  return [storage, reducer] as [typeof storage, typeof reducer]
}
